import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const fetchOrders = createAsyncThunk("orderHistory/fetchOrders", async (_,thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
     
  
    try {
      const res = await fetch( api + '/api/v1/orders?page=1', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      console.log(data);
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
});

export const OrdersSlice = createSlice({
  name: "orderHistory",
  initialState: { orders: null, loading: false, error: null },
  reducers: {},
  extraReducers:{
      [fetchOrders.pending]: (state) => {
        state.loading = true;
        state.error = null;
      },
      [fetchOrders.fulfilled]: (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      },

      [fetchOrders.rejected]: (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    }
});

export default OrdersSlice.reducer;
